require('./lbaPointsOfInterestListItem.scss');

const lbaPointOfInterestListItem = angular.module('app.lbaPointOfInterestListItem', []);

lbaPointOfInterestListItem.component('lbaPointOfInterestListItem', {
  bindings: {
    pointOfInterest: '=',
    editItem: '=',
    activateItem: '='
  },
  controller: lbaPointOfInterestListItemCtrl,
  template: `
  <div class="lbaPointsOfInterest_listItem" ng-click="$ctrl.activateItem($ctrl.pointOfInterest)">
      <h5 class="lbaPointsOfInterest_listItem_heading">{{ $ctrl.pointOfInterest.Title }}</h5>
      <div class="lbaPointsOfInterest_moreInfo" ng-if="$ctrl.pointOfInterest.active">
        <p class="lbaPointsOfInterest_listItem_description">{{ $ctrl.pointOfInterest.Description }}</p>
        <p class="lbaPointsOfInterest_listItem_address">{{ $ctrl.pointOfInterest.Address }}</p>
        <button class="lbaPointsOfInterest_listItem_edit" ng-click="$ctrl.editItem($ctrl.pointOfInterest)" title="Edit"><span class="fa fa-pencil-square-o"></span></button>
      </div>
  </div>
  `
});

function lbaPointOfInterestListItemCtrl() {
  let $ctrl = this;
}

export default lbaPointOfInterestListItem;


// WEBPACK FOOTER //
// ./src/components/lbaPointsOfInterestListItem/lbaPointsOfInterestListItem.js